import { render, staticRenderFns } from "./GenerativeAI.vue?vue&type=template&id=11ee064a&scoped=true"
import script from "./GenerativeAI.vue?vue&type=script&lang=js"
export * from "./GenerativeAI.vue?vue&type=script&lang=js"
import style0 from "./GenerativeAI.vue?vue&type=style&index=0&id=11ee064a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ee064a",
  null
  
)

export default component.exports